import React from "react";
import {Modal } from "antd";
import "./Modal.css"
import  closeModal from  "../../Images/icons/close-modal.svg"

const ModalNew = ({
  visible,
  onClose,
  style ={},
  title,
  children,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
  footer = null,
  ...rest
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      style={style}
      footer={footer}
      className={`custom-modal ${className}`} 
      centered
      closeIcon ={
        <img src={closeModal} alt="close-modal"  className="custom-close-icon"></img>
      }
      {...rest}
      title={
        <div className={`custom-modal-header ${headerClassName}`}>
          {title}
        </div>
      }
    >
      <div className={`custom-modal-body ${bodyClassName}`}>
        {children}
      </div>
      {footer && (
        <div className={`custom-modal-footer ${footerClassName}`}>
          {footer}
        </div>
      )}
    </Modal>
  );
};

export default ModalNew;
